import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.keys.js";
import _debounce from 'lodash/debounce';
export default defineComponent({
  props: {
    value: {
      type: [Number, String],
      default: ''
    },
    useNumberScrollWheel: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    timeout: {
      type: Number,
      default: 400
    }
  },
  setup: function setup(props, _ref) {
    var emit = _ref.emit,
      slots = _ref.slots;
    var parentSlots = computed(function () {
      return Object.keys(slots);
    });
    var blockScrollWheel = computed(function () {
      // Most default browser behaviour allows scrolling to change numbers in form input fields.
      // This is on by default for text fields (to allow the page to scroll as per usual)
      // This is off by default for number fields. useNumberScrollWheel will turn the scrolling on as needed.

      if (props.type === 'number') {
        if (props.useNumberScrollWheel) {
          return false;
        }
        return true;
      }
      return false;
    });
    var internalValue = ref(props.value);
    var touched = ref(false);
    var updateValue = _debounce(function (value) {
      touched.value = false;
      emit('input', value);
      emit('update:value', value);
    }, props.timeout);
    watch(function () {
      return props.value;
    }, function (value) {
      if (!touched.value) internalValue.value = value;
    });
    var updateInternalValue = function updateInternalValue(value) {
      touched.value = true;
      updateValue(value);
    };
    var handleWheel = function handleWheel(event) {
      if (blockScrollWheel.value) {
        event.preventDefault();
      }
    };
    onBeforeUnmount(function () {
      updateValue.flush();
    });
    return {
      internalValue: internalValue,
      handleWheel: handleWheel,
      updateInternalValue: updateInternalValue,
      parentSlots: parentSlots
    };
  }
});